import { get, find, indexOf, size } from 'lodash';
import storeProvider from '@peoplenet/vi-components-ui/src/store';

export const doesRequireSetup = () => {
  const store = storeProvider.getStore();

  const setup = get(store.getState(), 'security.userInfo.setup', {});

  if (!setup.hasDvrToolkitPassword) {
    return true;
  }

  if (!setup.hasServiceAccount) {
    return true;
  }

  return false;
};

export const getUserInfo = () => {
  const store = storeProvider.getStore();

  return get(store.getState(), 'security.userInfo', {});
};

export const hasAccess = (rolesWithAccess) => {
  const store = storeProvider.getStore();

  if (size(rolesWithAccess) === 0) {
    return true;
  }

  const userInformation = get(store.getState(), 'security.userInfo', {});
  if (
    indexOf(rolesWithAccess, 'changeCustomer') !== -1 &&
    userInformation.changeCustomer === true
  ) {
    return true;
  }

  return (
    find(rolesWithAccess, (r) => get(userInformation.roles, r, false)) !==
    undefined
  );
};

export const isInternalUser = () => {
  return hasAccess(['videoIntelligenceInternal']);
};

export const isManagerOrHigher = () =>
  hasAccess(['videoIntelligenceManager', 'videoIntelligenceAdmin']);
export const isAdmin = () => hasAccess(['videoIntelligenceAdmin']);
export const hasDeletePermission = () =>
  isManagerOrHigher() && !isInternalUser();
export const hasDownloadPermission = () =>
  isManagerOrHigher() && !isInternalUser();
export const hasOnDemandPermission = () =>
  isManagerOrHigher() && !isInternalUser();
export const hasOnDemandAccess = () => isManagerOrHigher() || isInternalUser();

export default hasAccess;
